import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || (path === '/' && location.pathname === '/dashboard');
  };

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <img 
              src="/pirkrecruiter-logo.png" 
              alt="PirkRecruiter Logo" 
              style={{ 
                height: '1.5rem',
                width: 'auto'
              }} 
            />
            <h1 className="logo">PirkRecruiting.AI</h1>
          </div>
          <div className="user-info">
            <span className="user-name">Demo User</span>
            <span className="user-role">Operations Recruiter</span>
          </div>
        </div>
      </header>
      
      <div className="layout-body">
        <aside className="sidebar">
          <nav className="sidebar-nav">
            <Link 
              to="/" 
              className={`sidebar-link ${isActive('/') ? 'active' : ''}`}
            >
              <span className="sidebar-icon">📊</span>
              <span className="sidebar-text">Dashboard</span>
            </Link>
            <Link 
              to="/candidates" 
              className={`sidebar-link ${isActive('/candidates') ? 'active' : ''}`}
            >
              <span className="sidebar-icon">👥</span>
              <span className="sidebar-text">Candidates</span>
            </Link>
            <Link 
              to="/jobs" 
              className={`sidebar-link ${isActive('/jobs') ? 'active' : ''}`}
            >
              <span className="sidebar-icon">📋</span>
              <span className="sidebar-text">Jobs</span>
            </Link>
            <Link 
              to="/users" 
              className={`sidebar-link ${isActive('/users') ? 'active' : ''}`}
            >
              <span className="sidebar-icon">👤</span>
              <span className="sidebar-text">Users</span>
            </Link>
            <Link 
              to="/agents" 
              className={`sidebar-link ${isActive('/agents') ? 'active' : ''}`}
            >
              <span className="sidebar-icon">🤖</span>
              <span className="sidebar-text">AI Agents</span>
            </Link>
          </nav>
          
          <div className="sidebar-footer">
            <div className="subscription-status">
              <div className="status-indicator active"></div>
              <div className="status-text">
                <div className="status-title">Active Trial</div>
                <div className="status-subtitle">30 days remaining</div>
              </div>
            </div>
          </div>
        </aside>
        
        <main className="main-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
